import { BookAIcon, CalculatorIcon, ClipboardCheckIcon, FileTextIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Power Distribution Formulas & Electrical Calculations Quick-Reference',
    description: 'The essential power distribution formulas and electrical calculations gathered in one quick-reference document.',
    icon: CalculatorIcon,
  },
  {
    number: '2',
    title: 'Switchgear & Switchboard Inspection Checklists',
    description: 'Inspection checklists for switchgear and switchboards, organized by equipment for fast review.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: 'How to Read Single-Line Diagrams, Control Schematics & Panel Drawings',
    description: 'A step-by-step guide to reading single-line diagrams, control schematics and panel drawings.',
    icon: FileTextIcon,
  },
  {
    number: '4',
    title: 'LV & MV Distribution Troubleshooting Field Guide',
    description: 'A structured guide to fault finding in low- and medium-voltage distribution systems.',
    icon: WrenchIcon,
  },
  {
    number: '5',
    title: 'Power Distribution & Switchgear Terminology Dictionary',
    description: 'An A–Z reference of the terms and acronyms used in power distribution and switchgear.',
    icon: BookAIcon,
  },
];
